export default __webpack_public_path__ + "static/media/asyncawaitjs.26d1bd0b.jpg";